import React from 'react';
import './HomePage.css';

function HomePage() {
  return (
    <div className="page">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="brand">
              <img src={"/images/icon.png"} alt="TeleReels Icon" className="brand-icon" />
              <div>
                <h1 className="brand-name">TeleReels</h1>
              </div>
            </div>
            <div className="badges">
              <a href="https://play.google.com/store/apps/details?id=com.telereels.app.android"
                target="_blank"
                rel="noopener noreferrer"
                className="badge-link">
                <img src={"/badges/google-play-badge.png"} alt="Google Play" className="badge" />
              </a>
              <a href="https://apps.apple.com/app/id6636523706"
                target="_blank"
                rel="noopener noreferrer"
                className="badge-link">
                <img src={"/badges/ios-badge.svg"} alt="App Store" className="badge" />
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="main">
        <div className="container">
          {/* Screenshots */}
          <section className="section">
            <h2 className="section-title">Telenovelas cortas, pasión y drama en cualquier momento</h2>
            <div className="screenshots">
              <img src={"/screenshots/1.png"} alt="Screenshot 1" className="screenshot" />
              <img src={"/screenshots/2.png"} alt="Screenshot 2" className="screenshot" />
              <img src={"/screenshots/3.png"} alt="Screenshot 3" className="screenshot" />
              <img src={"/screenshots/4.png"} alt="Screenshot 4" className="screenshot" />
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <h3 className="footer-title">Acerca de</h3>
            <div className="footer-info">
              <div>Contáctenos: <a href="mailto:contact@telereels.com">contact@telereels.com</a></div>
              <div><a href="/privacy">Política de privacidad</a></div>
              <div><a href="/terms">Términos de servicio</a></div>
              <div className="footer-address">Dirección: 113 N San Vicente Blvd, Beverly Hills, CA 90211, United States</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default HomePage;

